import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import OdooOrderView from "./OdooOrderView";
import { MT_SEND_ORDERS_TO_ODOO } from "./graphql";

const SendToOdooView = ({ orders, onCompleted }) => {
  const formattedOrders = orders.map((order) => {
    const orderId = order.recordID;
    const orderNumber = order.poNumber;
    const customerName = `${order.billToName} - ${order.buyerFirstName} ${order.buyerLastName}`;
    const salesRep = `${order.repGroup.recordID} - ${order.assignedSalespersonName}`;
    const invoiceAddress = `${order.billToAddress1}, ${order.billToAddress2}, ${order.billToCity}, ${order.billToState}, ${order.billToCountry} ${order.billToZip}`;
    const deliveryAddress = `${order.shipToAddress1}, ${order.shipToAddress2}, ${order.shipToCity}, ${order.shipToState}, ${order.shipToCountry} ${order.shipToZip}`;
    const warehouseName = "FSI / Stock";
    const incoterms = "";
    const pricelistName = "";
    const paymentTerm = order.paymentTerm;
    const orderTotal = order.orderTotal;
    const orderLines = order.orderLines.map((i) => ({
      id: i.recordID,
      name: i.name,
      number: i.itemNumber,
      unitPrice: i.unitPrice,
      qty: i.quantity,
      total: i.extendedPrice,
    }));
    return {
      orderId,
      orderNumber,
      customerName,
      invoiceAddress,
      deliveryAddress,
      warehouseName,
      incoterms,
      pricelistName,
      paymentTerm,
      orderTotal,

      odooCustomer: order.odooCustomer,
      odooDeliveryAddress: order.odooDeliveryAddress,

      orderLines,
    };
  });

  const [sendOrders, sendOrdersRes] = useMutation(MT_SEND_ORDERS_TO_ODOO, {
    variables: { ordersString: JSON.stringify(formattedOrders) },
    onCompleted() {
      Alert("success", "Orders sent to Odoo successfully");
      onCompleted();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_ODOO_MT_ORDERS"],
    awaitRefetchQueries: true,
  });

  console.log("orders", orders);

  const handleSendToOdoo = () => {
    const res = orders.map((order) => {
      const sourceId = order.recordID;
      const poNumber = order.poNumber;
      const odooCustomerId = order.odooCustomer.id;
      const odooRepgroupId = order.odooRepgroup.id;
      const odooDeliveryAddressId = order.odooDeliveryAddress.id;
      const orderLines = order.orderLines.map((i) => ({
        productOdooId: i.odooProduct.id,
        itemNumber: i.itemNumber,
        unitPrice: i.unitPrice,
        quantity: i.quantity,
      }));
      return {
        sourceId,
        poNumber,
        odooCustomerId,
        odooRepgroupId,
        odooDeliveryAddressId,
        orderLines,
      };
    });

    console.log("res", res);

    sendOrders({ variables: { ordersString: JSON.stringify(res) } });
  };

  return (
    <div className="text-sm">
      <div className="space-y-6">
        {formattedOrders.map((order, index) => (
          <OdooOrderView key={index} order={order} />
        ))}
      </div>

      <div className="mt-6">
        <Button
          primary
          onClick={handleSendToOdoo}
          loading={sendOrdersRes.loading}
        >
          Send to Odoo
        </Button>
      </div>
    </div>
  );
};

export default SendToOdooView;
